import classNames from 'classnames';
import PropTypes from 'prop-types';
import { FaSquareCheck } from 'react-icons/fa6';

const InputCheckbox = ({ color, className, label, labelClassName, checked, disabled, onChange, ...props }) => {
  const containerClasses = classNames('flex items-center text-sm cursor-pointer', {
    'opacity-50': disabled,
    'text-gray-400': !checked || color === InputCheckbox.COLORS.DEFAULT,
    'text-primary': checked && color === InputCheckbox.COLORS.PRIMARY,
    'text-secondary': checked && color === InputCheckbox.COLORS.SECONDARY,
    'text-white': checked && color === InputCheckbox.COLORS.WHITE,
  });

  const backgroundClasses = classNames({
    'bg-gray-400': !checked || color === InputCheckbox.COLORS.DEFAULT,
    'bg-primary': checked && color === InputCheckbox.COLORS.PRIMARY,
    'bg-secondary': checked && color === InputCheckbox.COLORS.SECONDARY,
    'bg-white': checked && color === InputCheckbox.COLORS.WHITE,
  });

  const borderClasses = classNames({
    'border-gray-400': !checked || color === InputCheckbox.COLORS.DEFAULT,
    'border-primary': checked && color === InputCheckbox.COLORS.PRIMARY,
    'border-secondary': checked && color === InputCheckbox.COLORS.SECONDARY,
    'border-white': checked && color === InputCheckbox.COLORS.WHITE,
  });

  return (
    <label className={`${containerClasses} ${className}`} htmlFor={props.id}>
      <input
        className="hidden"
        type="checkbox"
        name={props.name}
        id={props.id}
        checked={checked}
        onChange={onChange}
        {...props}
      />
      <div
        className={`flex items-center justify-center mr-2 ${borderClasses}`}
        style={{ minWidth: '16px', minHeight: '16px' }}
      >
        {checked ? (
          <FaSquareCheck className="w-4 h-4" />
        ) : (
          <div className="border border-gray-400 rounded-sm w-4 h-4" />
        )}
      </div>
      {label && <span className={labelClassName}>{label}</span>}
    </label>
  );
};

InputCheckbox.COLORS = {
  DEFAULT: 'DEFAULT',
  PRIMARY: 'PRIMARY',
  SECONDARY: 'SECONDARY',
  WHITE: 'WHITE',
};

InputCheckbox.propTypes = {
  color: PropTypes.oneOf(Object.values(InputCheckbox.COLORS)),
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  label: PropTypes.string,
  className: PropTypes.string,
  labelClassName: PropTypes.string,
};

InputCheckbox.defaultProps = {
  color: InputCheckbox.COLORS.SECONDARY,
  disabled: false,
  checked: false,
  onChange: () => {},
  label: '',
  className: '',
  labelClassName: '',
};

export default InputCheckbox;
